import React, { useEffect, useState } from 'react';
import { Tab, Tabs } from 'react-bootstrap';
import { Chart } from 'react-google-charts';
import moment from 'moment';
import { connect } from 'react-redux';
import { getPrice} from '../actions/symbol';
import { getReport, setReportLoading } from '../actions/report';
import { getCancelStickReport, setCandleStickReportLoading } from '../actions/candle_stick_report';
import { getVolumeReport, setVolumeReportLoading } from '../actions/volume_report';
import { getPriceListBySymbol } from '../actions/price_list';
import {  getForeignVolumeReport, setForeignVolumeReportLoading } from '../actions/foreign_volume_report';
import { getBuySellReport, setBuySellReportLoading } from '../actions/buy_sell_report';
import PriceChart  from './charts/PriceChart';
const Symbol: React.FC = (props: any) => {
    console.log(props);
    const [symbol, setSymbol] = useState<string>('');
    const [period, setPeriod] = useState<string>('default');
    const handleReport2Y = (e: React.MouseEvent<HTMLButtonElement>) => {
        e.preventDefault();
        setPeriod('2 Years');
        props.dispatch(getReport('2Y', symbol));
        props.dispatch(getCancelStickReport('2Y', symbol));
        props.dispatch(getVolumeReport('2Y', symbol));
        props.dispatch(getForeignVolumeReport('2Y', symbol));
        props.dispatch(getBuySellReport('2Y', symbol));
    }
    const handleReport1Y = (e: React.MouseEvent<HTMLButtonElement>) => {
        e.preventDefault();
        setPeriod('1 Year');
        props.dispatch(getReport('1Y', symbol));
        props.dispatch(getCancelStickReport('1Y', symbol));
        props.dispatch(getVolumeReport('1Y', symbol));
        props.dispatch(getForeignVolumeReport('1Y', symbol));
        props.dispatch(getBuySellReport('1Y', symbol));
    }
    const handleReport6M = (e: React.MouseEvent<HTMLButtonElement>) => {
        e.preventDefault();
        setPeriod('6 Months');
        props.dispatch(getReport('6M', symbol));
        props.dispatch(getCancelStickReport('6M', symbol));
        props.dispatch(getVolumeReport('6M', symbol));
        props.dispatch(getForeignVolumeReport('6M', symbol));
        props.dispatch(getBuySellReport('6M', symbol));
    }
    const handleReport3M = (e: React.MouseEvent<HTMLButtonElement>) => {    
        e.preventDefault();
        setPeriod('3 Months');
        props.dispatch(getReport('3M', symbol));
        props.dispatch(getCancelStickReport('3M', symbol));
        props.dispatch(getVolumeReport('3M', symbol));
        props.dispatch(getForeignVolumeReport('3M', symbol));
        props.dispatch(getBuySellReport('3M', symbol));
    }
    const handleReport1M = (e: React.MouseEvent<HTMLButtonElement>) => {    
        e.preventDefault();
        setPeriod('1 Month');
        props.dispatch(getReport('1M', symbol));
        props.dispatch(getCancelStickReport('1M', symbol));
        props.dispatch(getVolumeReport('1M', symbol));
        props.dispatch(getForeignVolumeReport('1M', symbol));
        props.dispatch(getBuySellReport('1M', symbol));
    }
    const handleReport1W = (e: React.MouseEvent<HTMLButtonElement>) => {
        e.preventDefault();
        setPeriod('1 Week');
        props.dispatch(getReport('1W', symbol));
        props.dispatch(getCancelStickReport('1W', symbol));
        props.dispatch(getVolumeReport('1W', symbol));
        props.dispatch(getForeignVolumeReport('1W', symbol));
        props.dispatch(getBuySellReport('1W', symbol));
    }

    useEffect(() => {
        const url = window.location.href;
        const symbol = url.substring(url.lastIndexOf('/') + 1);
        setSymbol(symbol);
        document.title = `${symbol} - bảng giá chứng khoán & chart | stock360`;
        var startDate = moment().subtract(3, 'months').format('YYYY-MM-DD');
        var endDate = moment().format('YYYY-MM-DD');
        props.dispatch(getPriceListBySymbol(symbol));
        props.dispatch(getPrice(symbol, startDate, endDate));
        
        setPeriod('1 Month');
        props.dispatch(setReportLoading(true));
        props.dispatch(setCandleStickReportLoading(true));
        props.dispatch(setVolumeReportLoading(true));
        props.dispatch(setForeignVolumeReportLoading(true));
        props.dispatch(setBuySellReportLoading(true));
        props.dispatch(getReport('1M', symbol));
        props.dispatch(getCancelStickReport('1M', symbol));
        props.dispatch(getVolumeReport('1M', symbol)); 
        props.dispatch(getForeignVolumeReport('1M', symbol));
        props.dispatch(getBuySellReport('1M', symbol));
    }, []);
    const chartOptions = {
        title: `Stock Price for ${symbol} over the last ${period}`,
        legend: {
          position: 'bottom',
          textStyle: {
            color: getComputedStyle(document.body).getPropertyValue('--bs-body-color'),
          },
        },
        backgroundColor: getComputedStyle(document.body).getPropertyValue('--bs-body-bg'),
        hAxis: {
          textStyle: {
            color: getComputedStyle(document.body).getPropertyValue('--bs-body-color'),
          },
        },
        vAxis: {
          textStyle: {
            color: getComputedStyle(document.body).getPropertyValue('--bs-body-color'),
          },
        },
        titleTextStyle: {
          color: getComputedStyle(document.body).getPropertyValue('--bs-body-color'),
          fontSize: 16,
        },
    };
    
    const candleStickChartOptions = {
        legend: 'none',
        title: `Candle Stick Chart for ${symbol} over the last ${period}`,
        bar: { groupWidth: '80%' },
        candlestick: {
          fallingColor: { strokeWidth: 0, fill: '#a52714' }, // red
          risingColor: { strokeWidth: 0, fill: '#0f9d58' },  // green
        },
        tooltip: { isHtml: true }
    };
    
    const volumeOptions = {
        isStacked: false,
        legend: { position: 'top'},
        title: `Total Volume of ${symbol} over the last ${period}`,
        series: {
            0: { targetAxisIndex: 0 }, // Volume
            1: { targetAxisIndex: 1 }, // Value
          },
        hAxis: {
            title: `Date`,
            slantedText: true,
            slantedTextAngle: 45,
        },
        vAxis: {
            0: {
                title: "Volume (Shares)",
                textStyle: { color: "#4285F4" },
                titleTextStyle: { color: "#4285F4" },
                fomrat: 'short'
            },
            1: {
                title: "Value (VND)",
                textStyle: { color: "#34a853" },
                titleTextStyle: { color: "#34a853" },
                format: 'short'
            },
        },
        tooltip: {
            isHtml: true,
            trigger: 'focus'
        },
        bar: { groupWidth: "70%" }, // adjust spacing
    };  

    const foreignVolumeOptions = {
        isStacked: false,
        legend: { position: 'top'},
        title: `Total Foreign Value of ${symbol} over the last ${period}`,
        
        hAxis: {
            title: `Date`,
            slantedText: true,
            slantedTextAngle: 45,
        },
        vAxis: {
            0: {
                title: "Value (VND)",
              
                fomrat: 'short'
            },
            1: {
                title: "Value (VND)",
                format: 'short'
            },
        },
        tooltip: {
            isHtml: true,
            trigger: 'focus'
        },        
        bar: { groupWidth: "70%" }, // adjust spacing
    };
    const buySellOptions={
        isStacked: false,
        legend: { position: 'top'},
        title: `Total Buy Sell Volum of ${symbol} over the last ${period}`,
        
        hAxis: {
            title: `Date`,
            slantedText: true,
            slantedTextAngle: 45,
        },
        vAxis: {
            0: {
                title: "Volumn",
              
                fomrat: 'short'
            },
            1: {
                title: "Value (VND)",
                format: 'short'
            },
        },
        tooltip: {
            isHtml: true,
            trigger: 'focus'
        },        
        bar: { groupWidth: "70%" }, // adjust spacing
    }
    return (
        <div className="p-6">
            <h2 className="text-2xl font-semibold mb-4">📈 {symbol}</h2>
            <h3>{props.symbolData!=null && props.symbolData.name}</h3>
            <div className='row'>
                <div className='col-12'>                
                    <Tabs defaultActiveKey="profile" id="uncontrolled-tab-example" className="mb-3">                        
                        <Tab eventKey="profile" title={<span><i className="fas fa-chart-line me-2"></i>Trending Report</span>}>
                                        <div className='row'>
                                            <div className='col-12 col-md-12 col-lg-3'></div>
                                            <div className='col-2 col-md-2 col-lg-1'>
                                               <div className='mb-1'>
                                                <button className='btn btn-light' onClick={handleReport2Y}>2Y</button>
                                               </div>
                                            </div>
                                            <div className='col-2 col-md-2 col-lg-1'>
                                               <div className='mb-1'>
                                                <button className='btn btn-light' onClick={handleReport1Y}>1Y</button>
                                               </div>
                                            </div>
                                            <div className='col-2 col-md-2 col-lg-1'>
                                               <div className='mb-1'>
                                                <button className='btn btn-light' onClick={handleReport6M}>6M</button>
                                               </div>
                                            </div>
                                            <div className='col-2 col-md-2 col-lg-1'>
                                               <div className='mb-1'>
                                                <button className='btn btn-light' onClick={handleReport3M}>3M</button>
                                               </div>
                                            </div>
                                            <div className='col-2 col-md-2 col-lg-1'>
                                               <div className='mb-1'>
                                                <button className='btn btn-light' onClick={handleReport1M}>1M</button>
                                               </div>
                                            </div>
                                            <div className='col-2 col-md-2 col-lg-1'>
                                               <div className='mb-1'>
                                                <button className='btn btn-light' onClick={handleReport1W}>1W</button>
                                               </div>
                                            </div>                                            
                                        </div>
                                        <div className='row'>
                                    <div className='col-12'>
                                        
                                        <div className='row'>
                                            <div className='col-12'>
                                            {props.loadingReport && <div className="text-gray-500">Loading report...</div>}
                                            {!props.loadingReport && (<PriceChart/>)}                                                
                                            </div>
                                        </div>
                                        <div className='row'>
                                            <div className='col-12'>
                                                {props.loadingBuySellReport && <div className="text-gray-500">.</div>}
                                                {!props.loadingBuySellReport && (<Chart
                                                    chartType="ColumnChart"
                                                    width="100%"
                                                    height="550px"
                                                    data={props.buySellReportData}
                                                    options={buySellOptions}
                                                />)}
                                                
                                            </div>
                                        </div>
                                        <div className='row'>
                                            <div className='col-12'>
                                                {props.loadingForeignVolumeReport && <div className="text-gray-500">.</div>}
                                                {!props.loadingForeignVolumeReport && (<Chart
                                                    chartType="ColumnChart"
                                                    width="100%"
                                                    height="550px"
                                                    data={props.foreignVolumeReportData}
                                                    options={foreignVolumeOptions}
                                                />)}
                                                
                                            </div>
                                        </div>
                                        
                                        <div className='row'>
                                            <div className='col-12'>
                                                {props.loadingCandleStickReport && <div className="text-gray-500">.</div>}
                                                {!props.loadingCandleStickReport && (<Chart
                                                chartType="CandlestickChart"
                                                width="100%"
                                                height="550px"
                                                data={props.candleStickReportData}
                                                options={candleStickChartOptions}
                                            />)}
                                            
                                            </div>
                                        </div>
                                        
                                        <div className='row'>
                                            <div className='col-12'>
                                                {props.loadingVolumeReport && <div className="text-gray-500">.</div>}
                                                {!props.loadingVolumeReport && (<Chart
                                                    chartType="ColumnChart"
                                                    width="100%"
                                                    height="550px"
                                                    data={props.volumeReportData}
                                                    options={volumeOptions}
                                                />)}
                                                
                                            </div>
                                        </div>
                                        
                                    </div>
                                </div> 
                        </Tab>
                        
                        <Tab eventKey="home" title={<span><i className="fas fa-table me-2"></i> Price</span>}>
                            {props.loadingPrice && <div className="text-gray-500">Loading prices...</div>}
                            {!props.loadingPrice && (
                                <div className="table-responsive">
                                    <table className="table table-hover">
                                        <thead className="bg-gray-100 text-gray-700 uppercase">
                                        <tr>
                                            <th className="px-4 py-2 border">Symbol</th>
                                            <th className="px-4 py-2 border">Date</th>
                                            <th className="px-4 py-2 border">Open</th>                                            
                                            <th className="px-4 py-2 border">High</th> 
                                            <th className="px-4 py-2 border">Low</th>  
                                            <th className="px-4 py-2 border">Close</th>                                            
                                        </tr>
                                        </thead>
                                        <tbody>
                                        {props.prices && props.prices.map((item: any, index: number) => (
                                            <tr key={index} className="hover:bg-gray-50">
                                                <td className="px-4 py-2 border">{item.symbol}</td>
                                                <td className="px-4 py-2 border">{item.date}</td>
                                                <td className="px-4 py-2 border">{item.price_open}</td>
                                                <td className="px-4 py-2 border">{item.price_high}</td>
                                                <td className="px-4 py-2 border">{item.price_low}</td>
                                                <td className="px-4 py-2 border">{item.price_close}</td>                                            
                                            </tr>
                                        ))}
                                        </tbody>
                                    </table>
                                </div>
                            )}
                        </Tab>
                    </Tabs>
                </div>
            </div>
        </div>
    );
}
const mapStateToProps = (state: any) => {
    console.log('Symbol: ',state)
    return {
        prices: state.symbol.prices,
        loadingPrice: state.symbol.loading,
        reportData: state.report.reportData,
        loadingReport: state.report.loading,
        candleStickReportData: state.candleStickReport.reportData,
        loadingCandleStickReport: state.candleStickReport.loading,
        volumeReportData: state.volumeReport.reportData,
        loadingVolumeReport: state.volumeReport.loading,
        symbolData: state.symbol.symbol,
        foreignVolumeReportData: state.foreignVolumeReport.reportData,
        loadingForeignVolumeReport: state.foreignVolumeReport.loading,
        buySellReportData: state.buySellReport.reportData,
        loadingBuySellReport: state.buySellReport.loading
    }
}
export default connect(mapStateToProps)(Symbol);